<template>
	<b-modal id="modal-sell" modal-class="modal-fullscreen1" inner-class="modal-sell" title="" @hidden="resetModal" hide-header hide-footer>
		<b-container fluid>
			<h2 class="text-right">
				<a href="javascript:;" class="mt-3 mr-3" @click="$bvModal.hide('modal-sell')">X</a>
			</h2>
			<div class="text-center">
				<b-img src="images/icono.svg" height="50" alt="logo"/>
			</div>
			<b-row class="pt-4">
				<b-col>
					<b-col cols="12" md="8" offset-md="2" v-if="showCallQuote">
						<h1 class="text-center mt-2">Déjanos tus datos para que nos contactemos contigo</h1>
						<b-form-group label="Nombre">
							<b-form-input v-model.trim="$v.phone_reservation.name.$model" :state="$v.phone_reservation.name.$dirty ? !$v.phone_reservation.name.$error : null"></b-form-input>
							<b-form-invalid-feedback id="input-1-live-feedback">
								Debes ingresar nombre.
							</b-form-invalid-feedback>
						</b-form-group>
						<b-form-group label="Apellido">
							<b-form-input v-model.trim="$v.phone_reservation.lastname.$model" :state="$v.phone_reservation.lastname.$dirty ? !$v.phone_reservation.lastname.$error : null"></b-form-input>
							<b-form-invalid-feedback id="input-1-live-feedback">
								Debes ingresar apellido.
							</b-form-invalid-feedback>
						</b-form-group>
						<b-col v-if="phone_reservation_loading" cols="12" class="text-center mt-5">
							<grid-loader :color="color"></grid-loader>
						</b-col>
						<b-row class="mt-4">
							<b-col class="text-center">
							<b-button size="lg" class=" mt-2 px-5" variant="outline-macal" @click="sendCallQuote">Enviar</b-button>
							</b-col>
						</b-row>
					</b-col>
					<b-col cols="12" md="8" offset-md="2" v-else-if="showSuccess">
						<b-row v-if="setSchedule">
							<b-col cols="12" class="bg-grey text-center p-4">
								<h4>{{data.brandText}} {{data.modelText}} {{data.versionText}}</h4>
								<h4>{{data.yearText}} | {{data.kmText}} KM</h4>
								<hr />
								<h1><b class="text-macal">$ {{car.offer}}</b></h1>
							</b-col>
							<b-col cols="12" class="bg-grey text-center mt-4 p-4">
								<h4>¡Únicos con <b>Doble Pago</b>!</h4>
								<div>
									Solo Macal te premia con un pago extra, descubre como <b><b-link v-b-toggle.accordion-1 class="text-macal">aquí</b-link></b>
									<b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
										<hr />
										<b-table-simple borderless>
											<b-tr>
												<b-td style="width: 10%; border-right: 2px">
													<h1 class="text-grey border-right-macal">01</h1>
												</b-td>
												<b-td class="text-left">
													Tomamos tu auto<br />
													<small>Cotiza tu <b>precio online</b>, agenda tu inspección y listo.</small>
												</b-td>
											</b-tr>
											<b-tr>
												<b-td style="width: 10%;">
													<h1 class="text-grey border-right-macal">02</h1>
												</b-td>
												<b-td class="text-left">
													Vendemos tu auto<br />
													<small>El auto será rematado <b>en los próximos 15 días</b>.</small>
												</b-td>
											</b-tr>
											<b-tr>
												<b-td style="width: 10%;">
													<h1 class="text-grey border-right-macal">03</h1>
												</b-td>
												<b-td class="text-left">
													Pago Extra: te damos 50% del excedente alcanzado<br />
													<small>Si precio de <b>venta supera el monto</b> que te pagamos inicialmente.</small>
												</b-td>
											</b-tr>
										</b-table-simple>
									</b-collapse>
								</div>
							</b-col>
							<b-col cols="12" class="bg-grey text-center mt-4 p-4">
								<h2><b>¡Listo!</b></h2>
								<p>Considera estos importantes puntos</p>
								<hr />
								<ul class="macal-ul text-justify" style="display: inline-block;">
									<li>Sólo puede entregar el vehículo el dueño del auto.</li>
									<li>Si tienes dudas contáctanos a <a href="mailto:particulares@macal.cl" > particulares@macal.cl</a>.</li>
									<li>Tu regreso asegurado en cabify.</li>
									<li>Sin notarías, nos encargamos de todos los trámites</li>
								</ul>
							</b-col>
						</b-row>
						<b-row v-else>
							<b-col md="6" offset-md="3" class="mt-5 text-center text-grey">
								<font-awesome-icon :icon="['fal', 'check-circle']" size="10x" class="text-macal" />
								<h1 class="my-4"><b>¡Te Llamaremos!</b></h1>
								<h4>Uno de nuestros ejecutivos se contactará contigo</h4>
							</b-col>
						</b-row>
					</b-col>
					<b-col deck v-else-if="showUserData">
						<b-row v-if="showConfirmData">
							<b-col cols="12">
								<b-link class="text-macal" @click="showConfirmData = false">
									<b><font-awesome-icon :icon="['fal', 'chevron-left']" />VOLVER</b>
								</b-link>
							</b-col>
							<b-col cols="12" md="8" offset-md="2">
								<b-row>
									<b-col>
										<h1 class="text-center mt-2">¡Estás a un Click!</h1>
								<h5 class="text-center">Hola {{phone_reservation.name}}, confirma el resumen de tu agenda</h5>
									</b-col>
								</b-row>
								<b-row>
									<b-col class="mt-2">
										Tu auto:
								<div class="bg-grey p-2"><b> {{data.brandText}} {{data.modelText}} {{data.versionText}}, {{data.yearText}}, {{data.kmText}} KM</b></div>
									</b-col>
								</b-row>
								<b-row>
									<b-col cols="12" md="6" class="mt-2">
										Cuando:
										<div class="bg-grey p-2"><b> {{reservation.date | moment("dddd D, MMMM")}}</b></div>
									</b-col>
									<b-col cols="12" md="6" class="mt-2">
										Donde:
										<div class="bg-grey p-2"><b> {{branch_id.Valor}}</b></div>
									</b-col>
								</b-row>
								<b-row>
									<b-col cols="12" md="6" class="mt-2">
										Hora:
										<div class="bg-grey p-2"><b> {{[reservation.hour, "HH:mm:ss"] | moment("HH:mm")}}</b></div>
									</b-col>
									<b-col cols="12" md="6" class="mt-2">
										Oferta:
										<div class="bg-grey p-2"><b> $ {{car.offer}}</b></div>
										<small>Oferta sujeta a modificaciones según inspección previa.</small>
									</b-col>
								</b-row>
								<b-col v-if="calendar_reservation_loading" cols="12" class="text-center mt-5">
									<grid-loader :color="color"></grid-loader>
								</b-col>
								<b-row class="mt-4">
									<b-col class="text-center">
									<b-button size="lg" class=" mt-2 px-5" variant="outline-macal" @click="sendReservation" :disabled="calendar_reservation_loading">Confirmar</b-button>
									</b-col>
								</b-row>
							</b-col>
						</b-row>
						<b-row v-else>
							<b-col cols="12">
								<b-link class="text-macal" @click="showUserData = false">
									<b><font-awesome-icon :icon="['fal', 'chevron-left']" />VOLVER</b>
								</b-link>
							</b-col>
							<b-col cols="12" md="8" offset-md="2">
								<h1 class="text-center mt-2">Completa tus datos</h1>
								<b-form-group label="Nombre">
									<b-form-input v-model.trim="$v.phone_reservation.name.$model" :state="$v.phone_reservation.name.$dirty ? !$v.phone_reservation.name.$error : null" ></b-form-input>
									<b-form-invalid-feedback id="input-1-live-feedback">
										Debes ingresar nombre.
									</b-form-invalid-feedback>
								</b-form-group>
								<b-form-group label="Apellido">
									<b-form-input v-model.trim="$v.phone_reservation.lastname.$model" :state="$v.phone_reservation.name.$dirty ? !$v.phone_reservation.lastname.$error : null" ></b-form-input>
									<b-form-invalid-feedback id="input-1-live-feedback">
										Debes ingresar apellido.
									</b-form-invalid-feedback>
								</b-form-group>
								<b-form-group label="Teléfono">
									<b-form-input v-model.trim="$v.reservation.phone.$model" :state="$v.reservation.phone.$dirty ? !$v.reservation.phone.$error : null"></b-form-input>
									<b-form-invalid-feedback id="input-1-live-feedback">
										Debes ingresar teléfono.
									</b-form-invalid-feedback>
								</b-form-group>
								<b-form-group label="Email">
									<b-form-input v-model.trim="$v.reservation.email.$model" :state="$v.reservation.email.$dirty ? !$v.reservation.email.$error : null"></b-form-input>
									<b-form-invalid-feedback id="input-1-live-feedback">
										Correo Inválido.
									</b-form-invalid-feedback>
								</b-form-group>
								<b-col cols="12" v-if="reservation.hour" class="text-right">
									<b-button size="lg" class=" mt-2 px-5" variant="outline-macal" @click="validateConfirmData()">Continuar</b-button>
								</b-col>
							</b-col>
						</b-row>
					</b-col>
					<b-col v-else-if="setSchedule">
						<b-row>
							<b-col>
								<b-row>
									<b-col>
										<h2 class="text-center mb-5">Agenda tu visita</h2>
									</b-col>
								</b-row>
								<b-row>
									<b-col cols="12"  md="6" lg="4" :class='{"text-right": true }'>
										<multiselect class="mb-4" style="z-index: 10000;" v-model="branch_id" :options="branches" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="Selecciona Sucursal" track-by="Id" label="Valor" @input="changeDate()">
											<template slot="noOptions">Debes seleccionar Sucursal primero.</template>
										</multiselect>
										<b-col v-if="calendar_get_dates_loading" cols="12" class="text-center mt-5 mb-5">
										<grid-loader :color="color"></grid-loader>
										</b-col>
										<datepicker class="w-100 mb-3" v-model="reservation.date" bootstrap-styling :disabled-dates="dateState.disabled" :highlighted="dateState.highlighted" :monday-first="true" :language="es" :inline="true"></datepicker>
										<!--
										<FunctionalCalendar v-model="calendarData" :isDatePicker="true"></FunctionalCalendar>
										-->
									</b-col>
									<b-col cols="12" md="6" lg="8">
										<div class="hours-list p-4" style="border: 1px solid #ccc;">
											<h5>{{hourTitle||"Selecciona una sucursal y fecha para ver los horarios disponibles"}}</h5>
											<b-col v-if="calendar_get_hours_loading" cols="12" class="text-center mt-5 mb-5">
												<grid-loader :color="color"></grid-loader>
											</b-col>
												<!--
											:class="{ active: auction.selected, 'shadow-sm p-0': true}" show v-for="(auction, index) in auctions" :key="index" :id="'auction-'+auction.id" :data-id="auction.id" :data-title="auction.title">
											<table @click="filterAuction"
											-->
											<h4 class="m-0 mt-3 px-2 col-6 col-md-4 col-lg-3 d-inline-block" v-for="(hour, index) in hours" :key="index" >
												<b-badge  :variant="(hour.selected ? 'macal' : 'light-grey')" :class="{ active: hour.selected, 'w-100 shadow-sm': true}" show  :id="'hour-'+hour.id" :data-title="hour.hour" @click="selectHour(hour)" >
													<b>{{hour.hour}}</b>
												</b-badge>
											</h4>
										</div>
									</b-col>
									<b-col cols="12" v-if="reservation.hour" class="text-right">
										<b-button size="lg" class=" mt-2 px-5" variant="outline-macal" @click="showUserData = true">Continuar</b-button>
									</b-col>
								</b-row>
							</b-col>
						</b-row>
					</b-col>
					<b-card-group deck v-else>
						<b-card v-if="car.offer" class="mx-0 mb-2 no-border text-center" border-variant="light">
							<b-card-text>
								<b-row>
									<b-col md="4" offset-md="4">
										<h2 class="text-center text-grey"><b> {{data.brandText}} {{data.modelText}} {{data.versionText}}, {{data.yearText}}, {{data.kmText}} KM </b></h2>
										<hr />
										<h5 class="text-center text-macal pt-4"><b>¡TE GARANTIZAMOS!</b></h5>
										<h1 class="text-macal mt-2 mb-5 display-4">
											<b>$ {{car.offer}}</b>
										</h1>
										<p class="text-center text-grey border-bottom-macal">
											¿Conoces el <b>Premio Macal</b>?
										</p>
										<p class="text-center text-grey my-2">
											Luego de hacer efectivo tu pago garantizado, venderemos tu auto, si lo hacemos por más de $ {{car.offer}}, <b>¡El 50% de excedente es tuyo! Ese es el Premio Macal.</b>
										</p>
										<b-row class="mt-5">
											<b-col cols="12" md="10" offset-md="1">
												<b-button size="lg" block class="mb-4" variant="macal" @click="setSchedule = true">Agendar Entrega</b-button>
												<b-button size="lg" block variant="macal" @click="showCallQuote = true">Quiero que me Llamen</b-button>
											</b-col>
										</b-row>
									</b-col>
								</b-row>
							</b-card-text>
						</b-card>
						<b-card v-else class="mx-0 mb-2 no-border text-center d-none d-md-block" border-variant="light" no-body>
							<b-card-text>
								<b-img src="images/vende/calmacal.jpg" class="w-100" fluid alt="calmacal"/>
							</b-card-text>
						</b-card>
						<b-card v-if="!car.offer" class="mb-2 ml-0 no-border shadow bg-grey col-md-4" border-variant="light">
							<b-card-text>
								<h4 class="text-center">Ingresa tu patente</h4>
								<b-row>
									<b-col md="8" offset-md="2">
										<b-form-group :invalid-feedback="car.plateInvalidFeedback" :state="car.plateState" description="Vehículos sin pérdida total y desde el 2013">
											<b-input-group class="mt-3">
												<b-form-input size="lg" v-model.trim="car.plate" :state="car.plateState" @keyup="uppercase" trim></b-form-input>
													<b-input-group-append>
														<b-button variant="info" @click="searchByPlate"><font-awesome-icon :icon="['fal', 'search']" size="lg" /></b-button>
													</b-input-group-append>
											</b-input-group>
										</b-form-group>
									</b-col>
								</b-row>
								<h5 class="text-center mt-2">O busca directamente tu automóvil</h5>
								<b-table-simple borderless condensed small class="mt-2">
									<b-tr>
										<b-td class="text-right">
											<multiselect class="multiselect-sm" v-model.trim="$v.car.brand.$model" :options="brands" :close-on-select="true" :show-labels="false" :loading="loading.brand" placeholder="Marca" track-by="value" label="text" @input="updateBrandText">
												<template slot="noOptions">No hay marcas disponibles.</template>
											</multiselect>
											<div class="invalid-feedback d-block" v-if="submited && !$v.car.brand.required">Debes ingresar Marca.</div>
										</b-td>
									</b-tr>
									<b-tr>
										<b-td class="text-right">
											<multiselect class="multiselect-sm"  v-model.trim="$v.car.year.$model" :loading="loading.year" :options="years" :close-on-select="true" :show-labels="false" placeholder="Año" track-by="value" label="text" @input="updateYearText">
												<template slot="noOptions">Debes seleccionar marca primero.</template>
											</multiselect>
											<div class="invalid-feedback d-block" v-if="submited && !$v.car.year.required">Debes ingresar Año.</div>
										</b-td>
									</b-tr>
									<b-tr>
										<b-td class="text-right ">
											<multiselect class="multiselect-sm"  v-model.trim="$v.car.model.$model" :loading="loading.model" :options="models" :close-on-select="true" :show-labels="false" placeholder="Modelo" track-by="value" label="text" @input="updateModelText">
												<template slot="noOptions">Debes seleccionar año primero.</template>
											</multiselect>
											<div class="invalid-feedback d-block" v-if="submited && !$v.car.model.required">Debes ingresar Modelo.</div>
										</b-td>
									</b-tr>
									<b-tr>
										<b-td class="text-right">
											<multiselect class="multiselect-sm"  v-model.trim="$v.car.version.$model" :loading="loading.version" :options="versions" :close-on-select="true" :show-labels="false" placeholder="Versión" track-by="value" label="text" @input="updateVersionText">
												<template slot="noOptions">Debes seleccionar modelo primero.</template>
											</multiselect>
											<div class="invalid-feedback d-block" v-if="submited && !$v.car.version.required">Debes ingresar Version.</div>
										</b-td>
									</b-tr>
									<b-tr>
										<b-td class="text-right">
											<multiselect class="multiselect-sm" v-model="car.km" :options="kms" :close-on-select="true" :show-labels="false" placeholder="Kilometraje" track-by="value" label="text" @input="updateKmText"></multiselect>
											<div class="invalid-feedback d-block" v-if="submited && !$v.car.km.required">Debes ingresar Kilometraje.</div>
										</b-td>
									</b-tr>
									<b-tr>
										<b-td class="text-right">
											<b-form-input size="sm" placeholder="E-Mail" v-model.trim="$v.reservation.email.$model" :state="$v.reservation.email.$dirty ? !$v.reservation.email.$error : null"></b-form-input>
											<b-form-invalid-feedback id="input-1-live-feedback">
												Email inválido.
											</b-form-invalid-feedback>
										</b-td>
									</b-tr>
									<b-tr>
										<b-td class="text-right">
											<b-form-input size="sm" placeholder="Teléfono" @keyup="addPlusToPhone" v-model.trim="$v.reservation.phone.$model" :state="$v.reservation.phone.$dirty ? !$v.reservation.phone.$error : null"></b-form-input>
											<b-form-invalid-feedback id="input-1-live-feedback">
												Número de teléfono incorrecto.
											</b-form-invalid-feedback>
										</b-td>
									</b-tr>
									<b-tr>
										<b-td colspan="2">
											<b-form-group>
												<b-form-checkbox v-model.trim="$v.car.terms.$model" value="accepted" unchecked-value="not_accepted" :state="$v.car.terms.$dirty ? !$v.car.terms.$error : null" @change="car.termsState=null">
													Acepto los <a href="https://www.macal.cl/MiSitio/Asset/Docs/T%c3%a9rminos%20y%20condiciones%20Particulares%20Macal.pdf" target="_blank">Términos y condiciones</a> *
													<b-form-invalid-feedback :state="car.termsState">Debes aceptar los términos y condiciones</b-form-invalid-feedback>
												</b-form-checkbox>
											</b-form-group>
											<b-form-invalid-feedback id="input-1-live-feedback">
												Debes Aceptar los términos y condiciones.
											</b-form-invalid-feedback>
										</b-td>
									</b-tr>
								</b-table-simple>
								<b-col v-if="send_loading" cols="12" class="text-center mt-5">
									<grid-loader :color="color"></grid-loader>
								</b-col>
								<b-col md="12" class="captcha-element text-center mt-3" >
									<vue-recaptcha ref="recaptcha" @verify="onVerify" :sitekey="captcha.sitekey"></vue-recaptcha>
								</b-col>
								<b-row>
									<b-col cols-md="12" v-if="this.errors" class="mt-3">
										<b-alert class="" variant="danger" show>{{ errors }}</b-alert>
									</b-col>
								</b-row>
								<b-col cols="12" class="text-center">
									<b-button size="lg" class=" mt-2 px-5" variant="outline-macal" @click="send">Revisa tu oferta</b-button>
								</b-col>
							</b-card-text>
						</b-card>
					</b-card-group>
				</b-col>
			</b-row>
		</b-container>
	</b-modal>
</template>

<script>
	import Datepicker from 'vuejs-datepicker';
	import {es} from 'vuejs-datepicker/dist/locale';
	import { required, minLength, maxLength, email } from "vuelidate/lib/validators";
	import VueRecaptcha from 'vue-recaptcha';

export default {
	name: 'v-sell-modal',
	components: {
		Datepicker,
		VueRecaptcha
	},
	props: {
		price: String,
		openModal: {default: false}
	},
	data (){
		return{
			send_loading: false,
			calendar_get_dates_loading: false,
			phone_reservation_loading: false,
			calendar_reservation_loading: false,
			calendar_get_hours_loading: false,
			showUserData: false,
			showConfirmData: false,
			showSuccess: false,
			showCallQuote: false,
			es: es,
			calendarData: {},
			setSchedule: false,
			captcha: {
				sitekey: process.env.VUE_APP_CAPTCHA_KEY,
				valid: false,
				error: false,
			},
			color: "#E4610C",
			car:{
				plate: '',
				brand: null,
				year: null,
				model: null,
				version: null,
				offer: null,
				terms: null,
				termsState: null,
				plateInvalidFeedback: null,
				plateState: null,
				km: null,
			},
			data: {
				brandText: '-',
				yearText: '-',
				modelText: '-',
				versionText: '-',
				kmText: '-'
			},
			plateData: {
				brand: null,
				year: null,
				model: null
			},
			loading: {
				brand: false,
				year: false,
				model: false,
				version: false,
			},
			errors: '',
			hour: "",
			date: "",
			brands: [],
			years: [],
			models: [],
			versions: [],
			kms: [
				{ value: 5000, text: "5.000" },
				{ value: 10000, text: "10.000" },
				{ value: 20000, text: "20.000" },
				{ value: 30000, text: "30.000" },
				{ value: 40000, text: "40.000" },
				{ value: 50000, text: "50.000" },
				{ value: 60000, text: "60.000" },
				{ value: 70000, text: "70.000" },
				{ value: 80000, text: "80.000" },
				{ value: 90000, text: "90.000" },
				{ value: 100000, text: "100.000" },
				{ value: 150000, text: "150.000" },
				{ value: 200000, text: "200.000" },
			],
			dateState: {
				disabled: {
					to: new Date,
					from: new Date,
				},
				highlighted: {}
			},
			branch_id: null,
			dateTitle: null,
			hourTitle: null,
			hours: [],
			reservation: {
				date: null,
				hour: null,
				quote_id: null,
				inspector_id: null,
				branch_id: null,
				name: null,
				lastname: null,
				email: null,
				phone: null,
				"g-recaptcha-response": ""
			},
			phone_reservation:{
				name: "",
				lastname: ""
			},
			submited: false,
		}
	},
	validations: {
		car:{
			brand: { required },
			year: { required },
			model: { required },
			version: { required },
			km: { required },
			terms: { required },
		},
		reservation: {
			phone: {required, minLength: minLength(12), maxLength: maxLength(12)},
			email: {required, email},
		},
		phone_reservation: {
			name: {required, minLength: minLength(3)},
			lastname: {required, minLength: minLength(3)},
		}
	},
	computed: {
		"car.plate": {
			get () { return this.car.plate },
			set (text) { this.car.plate = text.toUpperCase()}
		}
	},
	mounted() {
		this.$moment.locale('es');
		this.amount= this.price;
		if(this.openModal){
			this.$bvModal.show('modal-sell');
		}
	},
	methods: {
		addPlusToPhone(){
			if(this.reservation.phone !== null){
				this.reservation.phone = '+'+this.reservation.phone.replace(/[|&;$%@"<>()+a-zA-Z,]/g,"");
			}
		},
		validateConfirmData(){
			this.$v.phone_reservation.$touch()
			this.$v.reservation.$touch()
			if(!this.$v.phone_reservation.$invalid && !this.$v.reservation.$invalid) this.showConfirmData = true
		},
		onVerify: function (response) {
			if(response.length > 0){
				this.captcha.valid = true
				this.captcha.error = false
				this.reservation["g-recaptcha-response"] = response
			}
		},
		uppercase(){
			this.car.plate = this.car.plate.toUpperCase()
		},
		searchByPlate(){
			const cur = this;
			cur.loading.year = true;
			cur.loading.model = true;
			cur.loading.version = true;
			this.axios.get("cars/search_by_plate", {params: {plate: this.car.plate}}).then(result => {
				cur.car.plateInvalidFeedback = null
				cur.car.plateState = null
				cur.plateData.brand = { value: result.data.brand_id, text: result.data.brand}
				cur.plateData.year = { value: result.data.year_id, text: result.data.year}
				cur.plateData.model = { value: result.data.model_id, text: result.data.model}
				cur.car.brand = cur.plateData.brand;
				cur.data.brandText = cur.plateData.brand.text;
				cur.setYear();
				cur.cleanVersion();
			}).catch(() => {
				cur.car.plateInvalidFeedback = "Patente no entontrada"
				cur.car.plateState= false
				cur.$store.commit('hideLoading');
				cur.loading.year = false;
				cur.loading.model = false;
				cur.loading.version = false;
				cur.car.brand = null;
				cur.cleanYear();
				cur.cleanModel();
				cur.cleanVersion();
			})
		},
		updateBrandText(event) {
			this.$v.car.$touch()
			this.data.brandText = event.text;
			this.loading.year = true;
			this.setYear();
			this.cleanModel();
			this.cleanVersion();
		},
		updateYearText(event) {
			this.data.yearText = event.text;
			this.loading.model = true;
			this.setModel();
			this.cleanVersion();
		},
		updateModelText(event) {
			this.data.modelText = event.text;
			this.loading.version = true;
			this.setVersion();
		},
		updateVersionText(event) {
			this.data.versionText = event.text;
		},
		updateKmText(event) {
			this.data.kmText = event.text;
		},
		changeStep(value) {
			this.step = value;
		},
		changeBrand(elem) {
			this.car.brand = elem;
			this.updateBrandText(elem);
		},
		setBrand(){
			const cur = this;
			cur.loading.brand = true;
			this.axios.get("cars/get_sell_brands")
			.then(result => {
				cur.loading.brand = false;
				cur.brands = result.data;
			})
			.catch(() => {
				cur.loading.brand = false;
				cur.$store.commit('hideLoading');
			})
		},
		setYear(){
			this.cleanYear();
			const cur = this;
			cur.loading.year = true;
			this.axios.get("cars/get_sell_years", {params: {brand_id: this.car.brand.value}}).then(result => {
				cur.loading.year = false;
				cur.years = result.data;
				if(cur.plateData.year){
					cur.car.year = cur.plateData.year;
					cur.data.yearText = cur.plateData.year.text;
					cur.setModel();
				}
			}).catch(() => {
				cur.loading.year = false;
				cur.$store.commit('hideLoading');
			})
		},
		setModel(){
			this.cleanModel();
			const cur = this;
			cur.loading.model = true;
			this.axios.get("cars/get_sell_models", {params: {brand_id: this.car.brand.value, year_id: this.car.year.value}})
			.then(result => {
				cur.loading.model = false;
				cur.models = result.data;
				if(cur.plateData.model){
					cur.car.model = cur.plateData.model;
					cur.data.modelText = cur.plateData.model.text;
					cur.setVersion();
				}
			})
			.catch(() => {
				cur.loading.model = false;
				cur.$store.commit('hideLoading');
			})
		},
		setVersion(){
			this.cleanVersion();
			const cur = this;
			cur.loading.version = true;
			this.axios.get("cars/get_sell_versions", {params: {brand_id: this.car.brand.value, year_id: this.car.year.value, model_id: this.car.model.value}})
			.then(result => {
				cur.loading.version = false;
				cur.versions = result.data;
				cur.resetPlateData();
			})
			.catch(() => {
				cur.loading.version = false;
				cur.$store.commit('hideLoading');
			})
		},
		cleanYear(){
			this.years= []
			this.car.year = null;
			this.data.yearText = "-";
		},
		cleanModel(){
			this.models = []
			this.car.model = null;
			this.data.modelText = "-";
		},
		cleanVersion(){
			this.versions = []
			this.car.version = null;
			this.data.versionText = "-";
		},
		resetPlateData(){
			this.plateData.brand = null;
			this.plateData.year = null;
			this.plateData.model = null;
		},
		send(){
			this.$v.car.$touch()
			this.$v.reservation.$touch()
			this.submited = true
			if(!this.$v.car.$invalid && !this.$v.reservation.$invalid){
				if(this.captcha.valid){
					const cur = this;
					cur.send_loading = true
					this.axios.post("sells/quote", {car: this.car, user: { email: this.reservation.email, phone: this.reservation.phone, "g-recaptcha-response": this.reservation["g-recaptcha-response"] }}).then(result => {
						cur.car.offer = (result.data.Cotizacion.precio).toLocaleString('es');
						cur.reservation.quote_id = result.data.Cotizacion.idCotizacion;
						cur.branches = result.data.Sucursales;
						cur.$v.car.$reset()
						cur.$v.reservation.$reset()
						cur.submited = false
						cur.send_loading = false
						this.errors = ""
					})
					.catch(error => {
						cur.send_loading = false
						this.errors = error.data.data
					})
				}else{
					this.errors = "Debe validar captcha"
				}
			}
		},
		sendCallQuote(){
			const cur = this;
			this.$v.phone_reservation.$touch()
			if(!this.$v.phone_reservation.$invalid){
				this.phone_reservation_loading = true
				this.axios.post("sells/call_quote", { quote_id: this.reservation.quote_id, name: this.phone_reservation.name, lastname: this.phone_reservation.lastname } ).then(() => {
					cur.showCallQuote = false;
					cur.showSuccess = true;
					cur.phone_reservation_loading = false
				}).catch(() => {
					cur.phone_reservation_loading = false
				})
			}
		},
		sendReservation(){
			const cur = this;
			this.calendar_reservation_loading = true
			if(!this.$v.phone_reservation.$invalid && !this.$v.reservation.$invalid){
				this.reservation.name = this.phone_reservation.name
				this.reservation.lastname = this.phone_reservation.lastname
				this.axios.post("sells/reservation", this.reservation).then(() => {
					cur.showSuccess = true;
					this.calendar_reservation_loading = false
				})
				.catch(() => {
					this.calendar_reservation_loading = true
				})
			}
		},
		changeDate(){
			const cur = this;
			this.dateState = {disabled: { to: new Date,	from: new Date,	},	highlighted: {}	};
			this.reservation.date = null;
			this.calendar_get_dates_loading = true;
			this.axios.get("sells/get_dates", {params: { date: this.reservation.date, branch_id: this.branch_id.Id}}).then(result => {
				cur.hours = []
				cur.reservation.hour = null;
				cur.hourTitle = null;
				cur.dates = result.data;
				cur.dateTitle = result.data.message;
				this.calendar_get_dates_loading = false;
				let parsedDates = []
				for (let unavaliable_date of cur.dates.unavaliable_dates) {
					parsedDates.push(new Date(unavaliable_date));
				}
				cur.dateState.disabled = {
					to: new Date(cur.dates.min), // Disable all dates up to specific date
					from: new Date(cur.dates.max), // Disable all dates after specific date
					dates: parsedDates
				}
				cur.dateState.highlighted = {
					to: new Date(cur.dates.max), // Highlight all dates up to specific date
					from: new Date(cur.dates.min), // Highlight all dates after specific date
					includeDisabled: false // Highlight disabled
				}
			})
		},
		resetModal(){
			this.$v.car.$reset()
			this.$v.reservation.$reset()
			this.setSchedule = false;
			this.showSuccess = false;
			this.showCallQuote = false;
			this.showConfirmData = false;
			this.showUserData = false;
			this.calendar_get_dates_loading = false;
			this.calendar_get_hours_loading = false;
			this.phone_reservation_loading = false;
			this.calendar_reservation_loading = false;
			this.car = {
				plate: null,
				brand: null,
				year: null,
				model: null,
				version: null,
				offer: null,
				terms: null,
				termsState: null,
				plateInvalidFeedback: null,
				plateState: null,
				km: null,
			};
			this.phone_reservation= {
				name: "",
				lastname: ""
			},
			this.data = {
				brandText: '-',
				yearText: '-',
				modelText: '-',
				versionText: '-',
				kmText: '-'
			};
			this.plateData = {
				brand: null,
				year: null,
				model: null
			};
			this.dateState = {
				disabled: {
					to: new Date,
					from: new Date,
				},
				highlighted : {}
			};
			this.branch_id = null;
			this.dateTitle = "";
			this.hourTitle = null;
			this.hours = [];
			this.reservation = {
				date: null,
				hour: null,
				quote_id: null,
				inspector_id: null,
				branch_id: null,
				name: null,
				lastname: null,
				email: null,
				phone: null
			};
		},
		selectHour(hour){
			const cur = this;
			this.hours.forEach(function(el, index){
				cur.hours[index].selected = false;
			});
			hour.selected = true;
			this.reservation.hour = hour.hour_with_secs;
			this.reservation.inspector_id = hour.inspector_id;
			//document.querySelector(".hours-list").querySelector(".active").classList.remove("active");
			//document.getElementById("hour-"+hour.id).closest(".alert").classList.add("active");
			//this.auction = { name: event.target.closest(".alert").dataset.title, code: "auction", value: event.target.closest(".alert").dataset.id }
		}
	},
	watch: {
		'reservation.date': {
			handler:function(){
				const cur = this;
				cur.hours = [];
				cur.reservation.hour = null;
				if(this.branch_id !== null){
					cur.reservation.branch_id = this.branch_id.Id;
					cur.hourTitle = "";
					if(this.reservation.date !== null){
						this.calendar_get_hours_loading = true
						this.axios.get("sells/get_hours", {params: { date: this.reservation.date, branch_id: this.reservation.branch_id}}).then(result => {
							this.calendar_get_hours_loading = false
							cur.hours = result.data.hours;
							cur.hourTitle = result.data.message;
						})
					}
				}
			}
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
	#modal-sell___BV_modal_outer_{
		z-index: 1060 !important;
	}
	#modal-sell .multiselect-sm {
		height: 30px;
		font-size: 0.875rem !important;
		min-height: calc(1.5em + 0.5rem + 2px) !important;
		max-height: calc(1.5em + 0.5rem + 2px) !important;
		color: #35495e;
	}
	#modal-sell .multiselect-sm .multiselect__tags {
		height: 30px;
		font-size: 0.875rem !important;
		min-height: calc(1.5em + 0.5rem + 2px) !important;
		max-height: calc(1.5em + 0.5rem + 2px) !important;
		color: #35495e;
		padding: 0.25rem 0.5rem !important;
	}
	#modal-sell .multiselect-sm .multiselect__select {
		height: 30px;
		font-size: 0.875rem !important;
		min-height: calc(1.5em + 0.5rem + 2px) !important;
		max-height: calc(1.5em + 0.5rem + 2px) !important;
		padding: 0.25rem 0.5rem !important;
	}
	.w-100 .vdp-datepicker__calendar{
		width: 100%;
	}
	.captcha-element>div>div{
		margin-left: auto;
		margin-right: auto;
	}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
